<aside id="large-sidebar" class="sidebar fixed top-0 left-0 z-20 w-56 text-lg h-screen"
    [ngClass]="{ '-translate-x-full duration-700': sidebarStatus === 'small' }" aria-label="Sidebar">
    <div
        class="h-minus-4 ml-4 shadow-custom-1 rounded-b-lg p-4 overflow-y-auto bg-white border-r border-gray-300">
        <div id="large-sidebar-content">
            <ul class="space-y-2">
                <li>
                    <button 
                        (click)="navigateToPage('')"
                        class="flex flex-row items-center p-2 rounded-md hover:text-nside-orange-400 cursor-pointer"
                        [ngClass]="{'text-nside-orange-400': pageRoute === '' || pageRoute == 'dashboard'}">
                        <div class="w-6">
                            <lucide-icon [img]="icons.LayoutDashboard"></lucide-icon>
                        </div>
                        <span class="oswald-font ms-1">Dashboard</span>
                    </button>
                </li>
                <li class="group">
                    <button 
                        (click)="navigateToPage('evaluations')"
                        class="flex items-center w-full p-2 transition duration-75 rounded-md group-hover:text-nside-orange-400 cursor-pointer"
                        [ngClass]="{'text-nside-orange-400': pageRoute === 'evaluations'}">
                        <div class="w-6">
                            <lucide-icon [img]="icons.FileUser"></lucide-icon>
                        </div>
                        <span class="oswald-font flex-1 ms-1 text-left rtl:text-right whitespace-nowrap">
                            Evaluations
                        </span>
                    </button>
                </li>
                <li class="group">
                    <button 
                        (click)="navigateToPage('assessments')"
                        class="flex items-center w-full p-2 transition duration-75 rounded-md group-hover:text-nside-orange-400 cursor-pointer"
                        [ngClass]="{'text-nside-orange-400': pageRoute === 'assessments'}">
                        <div class="w-6">
                            <lucide-icon [img]="icons.ClipboardList"></lucide-icon>
                        </div>
                        <span class="oswald-font flex-1 ms-1 text-left rtl:text-right whitespace-nowrap">
                            Assessments
                        </span>
                    </button>
                </li>
                <li class="group">
                    <button 
                        (click)="navigateToPage('plans')"
                        class="flex items-start w-full p-2 transition duration-75 rounded-md group-hover:text-nside-orange-400 cursor-pointer"
                        [ngClass]="{'text-nside-orange-400': pageRoute === 'plans'}">
                        <div class="w-6 pt-1">
                            <lucide-icon [img]="icons.NotepadText"></lucide-icon>
                        </div>
                        <span class="oswald-font flex-1 ms-1 text-left rtl:text-right whitespace-nowrap">
                            Plans
                        </span>
                    </button>
                </li>
                <li class="group">
                    <button
                        (click)="navigateToPage('interventions')"
                        class="flex items-start w-full p-2 transition duration-75 rounded-md group-hover:text-nside-orange-400 cursor-pointer"
                        [ngClass]="{'text-nside-orange-400': pageRoute === 'interventions'}">
                        <div class="w-6 pt-1">
                            <lucide-icon [img]="icons.ShieldAlert"></lucide-icon>
                        </div>
                        <span class="oswald-font flex-1 ms-1 text-left rtl:text-right whitespace-nowrap">
                            Interventions
                        </span>
                    </button>
                </li>
                <li class="group">
                    <button
                        (click)="navigateToPage('monitoring')"
                        class="flex flex-row items-center p-2 rounded-md group-hover:text-nside-orange-400 cursor-pointer"
                        [ngClass]="{'text-nside-orange-400': pageRoute === 'monitoring'}">
                        <div class="w-6">
                            <lucide-icon [img]="icons.Target"></lucide-icon>
                        </div>
                        <span class="oswald-font ms-1">
                            Monitoring
                        </span>
                    </button>
                </li>
                <li class="group">
                    <button
                        (click)="navigateToPage('closed')"
                        class="flex flex-row items-center p-2 rounded-md group-hover:text-nside-orange-400 cursor-pointer"
                        [ngClass]="{'text-nside-orange-400': pageRoute === 'closed'}">
                        <div class="w-6">
                            <lucide-icon [img]="icons.ClipboardCheck"></lucide-icon>
                        </div>
                        <span class="oswald-font ms-1">
                            Closed
                        </span>
                    </button>
                </li>
            </ul>
        </div>
    </div>
    <div id="toggle-btn"
        class="absolute top-6 -right-6 py-3 bg-white border-r border-gray-300 cursor-pointer shadow-custom-1"
        (click)="$event.preventDefault(); toggleSidebar();">
        <lucide-icon [img]="icons.ChevronLeft"></lucide-icon>
    </div>
</aside>